import { render } from "./FigureAnimate.vue?vue&type=template&id=1785dc0a&scoped=true"
import script from "./FigureAnimate.vue?vue&type=script&lang=js"
export * from "./FigureAnimate.vue?vue&type=script&lang=js"

import "./FigureAnimate.vue?vue&type=style&index=0&id=1785dc0a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1785dc0a"]])

export default __exports__